<template>
  <div class="PublicResourceHeader">
    <div class="header-top width-100">
      <div class="f-level-between safe-area_width height-100 content">
        <div class="top-block">
          <div class="nav-con f-layout">
            <p v-if="!!username" class="welcome">欢迎你, {{ username }}</p>
            <p v-else class="welcome">您好，欢迎您来到千里马招标网</p>
            <p v-for="(item, index) in topNav" :key="item.id" class="nav-link" @click="clickNavHandle(item)">
              <template v-if="index < 2 && !username">
                <span class="hover-text_theme">{{ item.text }}</span>
                <span class="division-line">|</span>
              </template>
              <template v-else>
                <span
                  >[<span class="hover-text_theme">{{ item.text }}</span
                  >]
                </span>
              </template>
            </p>
          </div>
        </div>

        <div class="substation">
          <span class="substation-text theme-color_bg">分站</span>
          <a
            v-for="item in topSubstation"
            :key="item.text"
            :href="item.url"
            :title="item.title+'招标网'"
            target="_blank"
            class="substation-link"
            >{{ item.text }}</a
          >
          <span class="substation-more">
            更多>>
            <div class="substation-box">
              <ul class="fenquwrap">
                <li v-for="item in provinceList" :key="item.id">
                  <span class="fenqu">{{ item.name }}</span>
                  <a v-for="ite in item.children" :key="ite.id" :href="`/zb/area_${ite.id}/`"  :title="ite.name+'招标网'">{{ ite.name }}</a>
                </li>
              </ul>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="safe-area_width_2 f-level-between mt--10">
      <div class="logo-left">
        <a href="//www.qianlima.com">
          <img :src="`${imgPath}/oneold/layout/logo.gif`" class="logo-img" alt="" />
        </a>
        <h1>{{ publicResource.title }}</h1>
      </div>

      <div class="right-box f-layout">
        <div>
          <span class="hot-line">全国服务热线：</span>
          <img :src="pageType == 'hot' ? topPhoneHot : topPhone" alt="" class="hot-line-img" />
        </div>
        <div class="f-layout width-100 search-box">
          <input v-model="inputVal" type="text" placeholder="请输入您要输入的内容" />
          <div class="theme-color_bg search-btn" @click="goSearchPage">
            <img :src="`${imgPath}/oneold/layout/search.png`" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="theme-color_bg width-100 navs-bg f-l-center mt--20 mb--20">
      <div class="navs f-layout">
        <div v-for="item in topNavs" :key="item.text" class="single">
          <a :href="item.url">{{ item.text }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { imgPath, SEARCH_URL } from "@/utils/constants/constants";
import { topSubstation, otherNav, loginNav, topNavs } from "@/utils/constants/gjxx_data_moudle";
import { clearCookies } from "@/utils/common";
import { areaProvinceJSON } from "@/assets/areaProvinceJSON";

export default {
  name: "gjxx",
  components: {},
  data() {
    return {
      imgPath,
      pageType: "",
      inputVal: "",
      topPhone: `${imgPath}/oneold/layout/top_phone.gif`,
      topPhoneHot: `${imgPath}/oneold/layout/top_phone_hot.png`,
      provinceList: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    username() {
      return this.userInfo.username;
    },
    topSubstation() {
      return topSubstation;
    },
    otherNav() {
      return otherNav;
    },
    loginNav() {
      return loginNav;
    },
    topNav() {
      return this.username ? this.otherNav : [...this.loginNav, ...this.otherNav.slice(2)];
    },
    topNavs() {
      return topNavs;
    },
    publicResource() {
      return this.$store.getters["gjxx/listObj"];
    },
  },
  created() {
    this.provinceList = areaProvinceJSON.slice(0, areaProvinceJSON.length - 1);
  },
  mounted() {},
  methods: {
    clickNavHandle(item) {
      if (item.state && item.state === "handle") {
        this.$confirm("您确定要退出登录？?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            clearCookies();
            window.location.reload();
          })
          .catch(() => {});
      } else {
        window.open(item.url, "_blank", "");
      }
    },
    goSearchPage() {
      if (!this.inputVal) {
        this.$message({
          type: "warning",
          message: "请输入内容后搜索",
        });
        return;
      }
      const url = `${SEARCH_URL}?q=${this.inputVal}`;
      window.open(url, "_blank", "");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variable.scss";

.PublicResourceHeader {
  .header-top {
    height: 27px;
    background: rgb(238, 238, 238);
    border-bottom: 1px solid rgb(202, 202, 202);
  }

  .welcome {
    margin-right: 20px;
  }

  .nav-link {
    margin: 0 4px;

    .division-line {
      margin: 4px;
    }
  }

  .content {
    align-items: center;
  }

  .substation {
    display: flex;
    align-items: center;
    &-text {
      color: #fff;
      padding: 1px 5px;
    }

    &-link {
      margin: 0 4px;
    }
    &-more {
      position: relative;
      display: block;
      cursor: pointer;
      &:hover {
        .substation-box {
          visibility: visible;
        }
      }
    }
    &-box {
      position: absolute;
      visibility: hidden;
      margin: 0;
      padding: 0;
      background: #fff;
      border: 1px solid #f00;
      z-index: 999;
      width: 350px;
      position: absolute;
      right: 0;
      padding: 10px 5px;
      .fenquwrap {
        li {
          display: flex;
          line-height: 20px;
          padding: 5px 0;
          .fenqu {
            display: block;
            width: 51px;
            height: 19px;
            line-height: 19px;
            font-size: 12px;
            font-weight: bold;
            background: url(//file-smallv.qianlima.com/gw/newDefault/images/1_bg3.jpg) no-repeat left center;
            text-align: center;
          }
          a {
            position: relative;
            display: block;
            line-height: 20px;
            float: left;
            margin: 0;
            padding: 0 10px;
            width: auto;
            text-align: left;
            background: #fff;
            color: #2875de;
            z-index: 999;
            &:hover {
              color: #f00;
            }
          }
        }
      }
    }
  }
  .logo-left {
    display: flex;
    align-items: center;
    h1 {
      padding-top: 15px;
      padding-left: 10px;
    }
  }
  .logo-img {
    width: 140px;
    height: 80px;
  }

  .right-box {
    width: 50%;
    flex-direction: column;
    align-items: flex-end;
  }

  .hot-line {
    font-size: 16px;
    font-weight: 600;
  }

  .hot-line-img {
    vertical-align: middle;
  }

  .search-box {
    height: 50px;
    border: 2px solid $theme-color;
    justify-content: flex-end;

    input {
      border: none;
      flex: 1;
      padding: 6px;
    }

    .search-btn {
      width: 100px;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;

      img {
        width: 42px;
        height: 42px;
        margin: auto 0;
      }
    }
  }

  .navs {
    padding-top: 4px;

    .single {
      flex-shrink: 0;
      padding: 20px 20px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      a {
        color: #fff;
      }
      &:hover {
        background: #fff;

        a {
          color: $theme-color;
        }
      }
    }
  }
}
</style>
